import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Constant, BaseComponent } from '../../infrastructure/common';
import { Token, Menu } from '../../data/models/base';
import { TokenService, MenuService, CssConfigService, UserService } from '../../infrastructure/services/base';
import { filter } from 'rxjs/operators';

declare var jQuery: any;

@Component({
    selector: 'app-pages',
    templateUrl: './pages.html',
    styleUrls : ['./pages.css']
})

export class PagesComponent implements AfterViewInit {
  token: Token;
  userId: string;
  loginTime: string;
  navMenu: Menu[] = [];
  isDropdownOpen = false;
  breadcrumbs: Array<{ label: string; url: string }> = [];
  sidebarCollapsed = false;
  currentYear: number = new Date().getFullYear();
  currentUrl: string = '';

  custodianMenu: string[] = ['OP-98','OP-98-00','OP-98-01','OP-99','OP-99-01','OP-99-99'] 
  toggleSidebar() {
    this.sidebarCollapsed = !this.sidebarCollapsed;
  }

  toggleDropdown(event: any): void {
    if(this.sidebarCollapsed)
      this.toggleSidebar();

    event['isDropdownOpen'] = !event['isDropdownOpen']
  }

  constructor(
    private menuService: MenuService,
    private cssService : CssConfigService,
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
      }
    });
  }

  ngOnInit() {
      this.token = TokenService.getToken();
      this.userId = this.token.UserId;
      this.loginTime = this.token.LoginTime;

      this.setCssProperty(TokenService.getToken());
      this.isCustodian();
      this.breadcrumbs = this.createBreadcrumbs(this.route.root);

      this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.breadcrumbs = this.createBreadcrumbs(this.route.root);
      });
  }

  private createBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: Array<{ label: string; url: string }> = []): Array<{ label: string; url: string }> {
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');
      if (routeURL) {
        url += `/${routeURL}`;
      }

      if (child.snapshot.data['breadcrumb'] && !breadcrumbs.some(b => b.url === url)) {
        breadcrumbs.push({ label: child.snapshot.data['breadcrumb'], url });
      }

      return this.createBreadcrumbs(child, url, breadcrumbs);
    }

    return breadcrumbs;
  }

  setCssProperty(param : any){
    localStorage.setItem('OwnerCode', param.DefaultOwnerCode);
    this.cssService.getCssConfig(param.DefaultOwnerCode).subscribe(data => {
      data.Result.forEach(e => {
        if (e.CssClass == '--ifl-form-bg-color'){
          this.changeCssProperty('--ifl-form-bg-lighter-color', this.lightenColor((e.CssValue == null ? e.DefaultCssValue : e.CssValue), 20));
        }
        // console.log(e);
        this.changeCssProperty(e.CssClass, (e.CssValue == null ? e.DefaultCssValue : e.CssValue));
      })
    })
  }

  ngAfterViewInit() {
  }

  checkSameRoute(route: string){
    if (this.currentUrl.includes(route)) {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([route]);
      });
    }
  }

  getMenu(isCustodian: boolean) {
    this.menuService.getMenu("OP").subscribe(res => {
      let result = res.Result;

      if (isCustodian) {
        result = result.filter(menu => this.custodianMenu.includes(menu.MenuId));
      }

      result.forEach(elm => {
        let menu: Menu = new Menu();
        menu.MenuId = elm.MenuId;
        menu.MenuName = elm.MenuName;
        menu.ParentId = elm.ParentId;
        menu.NavigateUrl = elm.NavigateUrl != null ? elm.NavigateUrl : "";
        menu.Language = elm.Language;
        menu.ImageUrl = elm.ImageUrl;
        menu.MenuLevel = elm.Level;

        if(elm.Level == 1) {
            menu.isDropdownOpen = false;
            this.navMenu.push(menu);
        }
        else if(elm.Level > 1) {
            let parent = this.navMenu.findIndex(i => i.MenuId == elm.ParentId)
            this.navMenu[parent].SubMenu.push(menu);
        }
      });

      setTimeout(() => {
        jQuery(".float-menu-3").floatingMenu({
          position: ["left", "top"],
          offset: [0, 100],
          shape: "rounded-out",
          sideSpace: true,
          buttonSpace: true,
          labelSpace: true,
          labelConnected: true,
          labelEffect: "slide-out-fade",
          labelAnim: [500, "easeOutQuad"],
          color: "default",
          overColor: "default",
          labelsOn: true,
          subPosition: "under",
          subSpace: false,
          subEffect: "linear-slide",
          subAnim: [400, "easeOutQuad"],
          windowPosition: ["center", "top"],
          windowOffset: [0, 0],
          windowCorners: "round",
          windowColor: "blue",
          windowShadow: false,
        });
      }, 1000);
    });
  }


  changeCssProperty(paramName: string, value: string): void {
    // Access the :root element
    const root = document.documentElement;
    root.style.setProperty(paramName, value);
  }

  lightenColor(hex: string, percent: number): string {
    // Ensure hex starts with a '#'
    if (hex.startsWith('#')) {
        hex = hex.slice(1);
    }

    // Convert 3-digit hex to 6-digit
    if (hex.length === 3) {
        hex = hex.split('').map(c => c + c).join('');
    }

    // Parse r, g, b values
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    // Increase rgb values by the percentage
    r = Math.min(255, Math.floor(r * (1 + percent / 100)));
    g = Math.min(255, Math.floor(g * (1 + percent / 100)));
    b = Math.min(255, Math.floor(b * (1 + percent / 100)));

    // Convert back to hex and return
    return `#${(r.toString(16)).padStart(2, '0')}${(g.toString(16)).padStart(2, '0')}${(b.toString(16)).padStart(2, '0')}`;
  }

  isCustodian() {
    let self = this;        
    self.userService.isCustodian()
      .subscribe(data => {
        let message = data;  
        if (message && message.MessageType && message.MessageType.Value) {
          console.log(message);
          if (message.MessageType.Value === "INFORMATION" ){
          self.getMenu(true);
        }else{
          self.getMenu(false);
        }            
      } else {
        console.log('error'+data);
      }
    },
    error => {
      console.log('error'+error);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/views/pages/pages.component.ts